import React from 'react';
import {observer} from 'mobx-react';
import SaveButton from './saveButton';
import auditDataStore from '../../stores/license/auditDataStore';

const LicenseFormFooter: React.FC = observer(() => {
    const formatDate = (date: Date) => {
        return date.toUTCString() + ' (' + date.toLocaleString() + ' local time)';
    };

    const selectedAudit = auditDataStore.selectedAudit;
    const endDate = selectedAudit ? new Date(selectedAudit.endDate) : null;
    const startDate = selectedAudit ? new Date(selectedAudit.startDate) : null;

    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '20px',
            padding: '0 40px'
        }}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'flex-start'}}>
                {endDate && startDate && (
                    <>
                        <p>Created on {formatDate(startDate)}</p>
                    </>
                )}
            </div>
            {!auditDataStore.selectedAudit?.isCompleted && <SaveButton/>}
        </div>
    );
});

export default LicenseFormFooter;